module.exports = __webpack_public_path__ + "img/蜡烛.2a811b38.gif";